/* Whether the shell should stand down for the checkout's own logo-only bar.

   The unified checkout runs its whole flow on one route, so the shell cannot
   tell the form apart from the receipt by pathname — which is why the site nav
   stayed hidden on the thank-you step, where the shopper is done and wants the
   site back. The step says which it is; the shell listens.

   A module-level signal rather than context because App is a class component
   and the checkout is mounted through a Route beneath it, the same reason the
   cart drawer publishes its handle this way. */
let isBare = false;
const listeners = new Set();

/* The footer, separately. The receipt shares its URL with the other two arms,
   which keep their footer there, so the pathname cannot decide this one. */
let footerHidden = false;
const footerListeners = new Set();

export const subscribeToChrome = (fn) => {
  listeners.add(fn);
  fn(isBare);
  return () => listeners.delete(fn);
};

export const setBareChrome = (next) => {
  if (isBare === next) return;
  isBare = next;
  listeners.forEach((fn) => fn(isBare));
};

export const isBareChrome = () => isBare;

export const subscribeToFooterHidden = (fn) => {
  footerListeners.add(fn);
  fn(footerHidden);
  return () => footerListeners.delete(fn);
};

export const isFooterHidden = () => footerHidden;

export const setFooterHidden = (next) => {
  if (footerHidden === next) return;
  footerHidden = next;
  footerListeners.forEach((fn) => fn(footerHidden));
};

export default {
  subscribeToChrome,
  setBareChrome,
  isBareChrome,
  subscribeToFooterHidden,
  setFooterHidden,
  isFooterHidden,
};
